import { Component, inject } from '@angular/core';
import { ThemeService } from '../services/theme';
import { ResponsiveService } from '../services/responsive';
import { v3LayoutFlags } from '../services/v3-layout';
import { regwallActions } from '../services/regwall-actions';

// V3's floating signup/login card for Finnet guests — rendered by V3Root over the blurred
// page (see regwall-info/CLAUDE.md's V3 section). Same actions/analytics as V2's RegwallInfo.
@Component({
  selector: 'app-v3-regwall-info',
  templateUrl: './v3-regwall-info.html',
  styleUrl: './v3-regwall-info.scss',
  standalone: true,
  imports: [],
})
export class V3RegwallInfo {
  private readonly actions = regwallActions();
  private readonly themeService = inject(ThemeService);
  private readonly responsiveService = inject(ResponsiveService);

  private readonly layout = v3LayoutFlags(this.themeService, this.responsiveService);
  readonly isFinnetDesktop = this.layout.isFinnetDesktop;

  onSignup(): void {
    this.actions.onSignup();
  }

  onLogin(): void {
    this.actions.onLogin();
  }
}
